import { CheckoutForm } from "../../components/CheckoutForm/CheckoutForm";

export const Checkout = () => {
    return (
        <CheckoutForm />
    )
}